import { Controller, useFormContext } from "react-hook-form"

import { Stack, TextField, Divider, IconButton, SvgIcon, Typography, Box } from "@mui/material"
import { DeleteBin6LineIcon } from "@equipmentshare/ds2-icons"

import BulkPartPicker from "@app/components/pickers/bulk-part-picker/BulkPartPicker"

type BulkPartSelectionProps = {
	deleteable?: boolean
	onDelete?: () => void
	name?: string
	index: number
}

export const BulkPartSelection: React.FC<BulkPartSelectionProps> = ({ deleteable, onDelete, name, index }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext()

	// Get errors for this specific item using the index
	const bulkPartSelectionErrors = errors?.bulkPartSelection as any[] | undefined
	const itemErrors = bulkPartSelectionErrors?.[index] as any
	const partError = itemErrors?.part
	const countError = itemErrors?.count

	const paddingBottom: React.CSSProperties = { paddingBottom: "10px" }

	return (
		<Stack spacing={1} sx={paddingBottom}>
			{index > 0 && <Divider sx={paddingBottom} />}
			<Controller
				name={`${name}.part`}
				control={control}
				render={({ field }) => (
					<BulkPartPicker field={field} error={!!partError} helperText={partError?.message} />
				)}
			/>
			<Box>
				<Typography variant="subtitle2" fontWeight="bold" sx={{ marginBottom: "4px" }}>
					Quantity
				</Typography>
				<Stack direction="row" alignItems="center" justifyContent="space-between">
					<Controller
						name={`${name}.count`}
						control={control}
						render={({ field }) => (
							<TextField
								type="number"
								size="small"
								sx={{ width: "120px" }}
								placeholder="Count"
								value={field?.value ?? 1}
								onChange={(e) => field.onChange(e.target.value)}
								error={!!countError}
								helperText={countError?.message}
							/>
						)}
					/>

					{deleteable && (
						<IconButton
							onClick={onDelete}
							children={<SvgIcon component={DeleteBin6LineIcon} sx={{ color: "black" }} />}
						/>
					)}
				</Stack>
			</Box>
		</Stack>
	)
}
export default BulkPartSelection
